import { LitElement } from './-global.min.js'

class ProductCardWrapper extends LitElement {
  static properties = {
    productUrl: {
      type: String,
      attribute: 'product-url',
    },

    _productSwatches: {
      state: true,
    },
  }

  connectedCallback() {
    this.onHandleVariantChange = this.onHandleVariantChange.bind(this)
    this.handleAccessibleLink = this.handleAccessibleLink.bind(this)

    this.variantButtons = [...this.querySelectorAll('[data-variant-button]')]
    this.variantButtons.forEach((button) => {
      button.addEventListener('click', this.onHandleVariantChange)
    })
    this.checkProductSwatches()

    this.querySelector('[data-featured-link]').addEventListener(
      'click',
      this.handleAccessibleLink
    )

    // stores the current 'default' swatch order (to avoid reordering on swatch change)
    this._productSwatches = this.getProductSwatches()
  }

  disconnectedCallback() {
    this.variantButtons.forEach((button) => {
      button.removeEventListener('click', this.onHandleVariantChange)
    })

    this.querySelector('[data-featured-link]').removeEventListener(
      'click',
      this.handleAccessibleLink
    )
  }

  handleAccessibleLink() {
    const link = this.querySelector('[data-featured-link]').getAttribute(
      'data-featured-link'
    )
    if (link) {
      window.location.href = link
    }
  }

  getProductSwatches() {
    return this.querySelector('.swatch-colors')
  }

  // removes the active style and the aria-current from all swatches
  clearActiveState(swatchesUl) {
    const swatches = swatchesUl.querySelectorAll('.swatch-color-button')
    swatches.forEach((swatch) => {
      swatch.classList.remove('active')
      swatch.querySelector('button')?.removeAttribute('aria-current')
    })
    return swatchesUl.innerHTML
  }

  addNewActiveState(swatchesElement, activeSwatch) {
    const newActiveSwatch = swatchesElement.querySelector(
      `[data-product-handle="${activeSwatch}"]`
    )
    newActiveSwatch.classList.add('active')
    newActiveSwatch
      .querySelector('button')
      ?.setAttribute('aria-current', 'true')
  }

  async checkProductSwatches() {
    const swatches = this.querySelectorAll(
      '.swatch-color-button[data-product-handle]'
    )
    const wrapper = this?.parentElement

    for (let i = 0; i < swatches.length; i++) {
      const url = `${window.Shopify.routes.root}products/${swatches[i].dataset.productHandle}.json`
      const response = await fetch(url)

      if (response.status === 404) {
        const styles = `
          [data-product-handle="${swatches[i].dataset.productHandle}"] {
            display: none !important;
          }
        `
        const styleSheet = document.createElement('style')
        styleSheet.textContent = styles
        wrapper?.appendChild(styleSheet)
      }
    }
  }

  async onHandleVariantChange(event) {
    event.preventDefault()
    const newProductSwatch = event.currentTarget.dataset.url.replace(
      '/products/',
      ''
    )
    try {
      const link = `${event.currentTarget.dataset.url}${
        event.currentTarget.dataset.url.includes('?')
          ? '&sections=product-card'
          : '?sections=product-card'
      }`
      const res = await fetch(link)
      if (!res.ok) throw new Error(res.status)

      const text = await res.json()
      const resultsMarkup = new DOMParser()
        .parseFromString(text['product-card'], 'text/html')
        .querySelector('product-card-wrapper')

      resultsMarkup.querySelector('.swatch-colors').innerHTML =
        this.clearActiveState(this._productSwatches)

      this.addNewActiveState(resultsMarkup, newProductSwatch)

      this.classList.add('fade-out')

      setTimeout(() => {
        this.innerHTML = resultsMarkup.innerHTML
        this.connectedCallback()
        setTimeout(() => {
          this.classList.remove('fade-out')
        }, 0)
      }, 100)
    } catch (error) {
      console.error('An error occurred in the predictive search request: ', {
        error,
      })
    }
  }
}
customElements.define('product-card-wrapper', ProductCardWrapper)
